export default async id => {
  const Pusher = await import(/* webpackChunkName: "pusher" */ 'pusher-js')
  if (ENV === 'staging') {
    return new Pusher(PUSHER_KEY, { 
      authEndpoint: `${IPVM_URL}/pusher/auth_export/${id}`,
      auth: {
        headers: {
          'Authorization': 'Basic ' + btoa(BASIC_AUTH_USERNAME + ':' + BASIC_AUTH_PASSWORD)
        }
      }
     }).subscribe(`private-calculator-export-${id}`)
  } else {
    return new Pusher(PUSHER_KEY, { authEndpoint: `${IPVM_URL}/pusher/auth_export/${id}` })
      .subscribe(`private-calculator-export-${id}`)
  }
}


// WEBPACK FOOTER //
// ./src/helpers/configPusher.js